// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from './PageEvents'
import PageHeader from './PageHeader'
import Content from './Content'
import Magazine from './Magazine'
import Events from './Events'
import People from './People'
import EventsPeople from './EventsPeople'
import Colleges from './Colleges'
import Videos from './Videos'

class Page extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		if ( ! this.props.match.params.video ) {
			window.scrollTo( 0, siteData.page_top_pos )
			document.querySelector( '.main' ).scrollTop = 0
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const { params } = this.props.match
		document.title = page.title.raw

		let showPageHeader = false

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div>
				<PageEvents />

				{ showPageHeader &&
					<PageHeader />
				}

				{ 'events-conference' == page.template &&
					<EventsPeople { ...this.props } />
				}

				<Content />

				{ ( 'people' == page.template || 'board' == page.template ) &&
					<People { ...this.props } />
				}

				{ 'magazine' == page.template &&
					<Magazine />
				}

				{ 'events' == page.template &&
					<Events />
				}

				{ 'colleges' == page.template &&
					<Colleges />
				}

				{ ( 'featured-videos' == page.template || params.video ) &&
					<Videos { ...this.props } />
				}
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				{ pageContent }
			</div>
		)
	}

	render() {
		const { isLoading } = this.props

		return (
			<div>
				{ isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Page )



// WEBPACK FOOTER //
// ./views/page/Page.jsx